module.exports = __webpack_public_path__ + "img/5.a24b71f9.jpg";